'use strict';

require('./flatten-a717674f.js');
var variadic = require('./variadic.js');

/**
 * Composes the given functions from left-to-right.
 *
 * @function
 * @param {Array} fs The functions to compose.
 * @returns {Function} A function that is the composition of the list of
 * functions `fs`.
 * @example
 *
 * import { compose } from 'fkit'
 * pipe(f, g, h)(a) // h(g(f(a)))
 */

var pipe = variadic(function (fs) {
  return function (a) {
    return fs.reduce(function (a, f) {
      return f(a);
    }, a);
  };
});

module.exports = pipe;
